<div class="task-step-a" [formGroup]="formGroup">
  <h2 class="col-12" *ngIf="false">Configuration</h2>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label
          i18n-title="floating text explaining task name relevancy|The floating text that shows up at the task name label when editing a task to provide context as to what it is useful for@@floatingTextDescribingTaskName"
          title="The task name helps separate and organize tasks"
          i18n="task name label at task edit form|The task name label that is present before the task name input at the task edit form@@taskNameLabelTaskEditForm">Task
          Name</label>
        <div class="input-wrapper">
          <input type="text" class="form-control" formControlName="TaskName" />
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label
          class="typeFiles"
          i18n="report type file label|The label before the report type selector that chooses the format of the file the task will be delivered with@@fileReportTypeLabelTaskForm">Report
          Type File</label>
        <div class="input-wrapper">
          <select class="form-control" #taskTypeSelect (change)="onTaskTypeChange($event)">
            <option value="image-attachment"
              i18n="image with attachment report option|The option for the report type file that correspond to an image as an email attachement@@reportTypeOptionImageAttachment">
              Image - Attachment</option>
            <option value="image-body"
              i18n="image in body report option|The option for the report type file that correspond to an image attached to the email body@@reportTypeOptionImageBody">
              Image - E-mail Body</option>
            <option value="unencrypted-pdf"
              i18n="unencrypted pdf report option|The option for the report type file that correspond to a unencrypted pdf attachment@@reportTypeOptionUnencryptedPDF">
              PDF</option>
            <option value="encrypted-pdf"
              i18n="encrypted pdf report option|The option for the report type file that correspond to a encrypted pdf attachment@@reportTypeOptionEncryptedPdf">
              PDF (Encrypted)</option>
          </select>
        </div>
      </div>
    </div>
  </div>


  <div class="form-group">
    <label class="pbi-workspace-label"
      i18n-title="The floating text shown when the cursor is in the label that represents the powerbi workspace label form input@@floatingTextPowerBIWorkspaceInput"
      title="The workspace in which the report was published">
      <span
        i18n="power bi workspace label at task edit form|The Power BI workspace label that is present before the powerbi selector@@powerBiWorkspaceInputLabelTaskEditForm">Power
        BI Workspace</span>
      <button placement="top"
        i18n-ngbTooltip="refresh power bi workspace list tooltip|Toolip that shows up when the user passes his mouse over the button that updates the powerbi data@@refreshPowerBiButtonTooltipTaskEditForm"
        ngbTooltip="Updates the list of Power BI workspaces from the service" type="button" role="button"
        class="btn btn-primary btn-xs" (click)="onRefreshWorkspaceButtonClick()"><i class='fa fa-refresh'></i></button>
    </label>
    <div class="input-wrapper">
      <select class="form-control" formControlName="PBIWorkspaceId" *ngIf="workspaceList && workspaceList.length > 0"
        (change)="onWorkspaceChangeInternal($event)">
        <option *ngFor="let workspace of workspaceList" [value]="workspace.id">{{ workspace.label }}</option>
      </select>
      <div class="form-control loading-wrapper" *ngIf="!workspaceList">
        <i class="fa fa-circle-o-notch fa-spin"></i>
      </div>
      <input type="text" class="form-control warning" disabled *ngIf="workspaceList && workspaceList.length <= 0"
        i18n-value="no available workspace in task creation warning|The text that show up at the page selector if there are no workspaces in the account to be selected@@noAccessibleWorkspacesAvailableWarning"
        value="There are no accessible workspaces in your account" />
    </div>
  </div>
  <div *ngIf="PBIWorkspaceId.invalid && (PBIWorkspaceId.dirty || PBIWorkspaceId.touched)" class="alert alert-danger">
    <div *ngIf="PBIWorkspaceId.errors.required"
      i18n="powerbi workspace empty or unselected|The error message when the powerbi workspace is empty or not selected, letting the user know it is required@@requiredPowerBiWorkspaceTaskEditForm">
      The PowerBI workspace is required</div>
    <div *ngIf="PBIWorkspaceId.errors.minlength"
      i18n="powerbi workspace incorrect or invalid|The error message when the powerbi workspace is not empty, but invalid or with a broken URL@@incorrectPowerBiWorkspaceTaskEditForm">
      The PowerBI workspace is in the wrong format and cannot be used</div>
  </div>
  <div class="form-group">
    <label
      i18n-title="floating text explaining power bi report relevancy|The floating text that shows up at the power bi report label when editing a task to provide context as to what it is useful for@@floatingTextDescribingPowerBiReport"
      title="The specific report or pbix file with the pages you want to send"
      i18n="power bi report label at task edit form|The Power BI report label that is present before the powerbi report selector@@powerBiReportInputLabelTaskEditForm">Power
      BI Report</label>
    <div class="input-wrapper">
      <select class="form-control" formControlName="PBIReportId" *ngIf="reportList && reportList.length > 0"
        (change)="onReportChangeInternal($event)">
        <option value="" disabled hidden></option>
        <option *ngFor="let report of reportList" [value]="report.id">{{ report.label }}</option>
      </select>
      <div class="form-control loading-wrapper" *ngIf="!reportList">
        <i class="fa fa-circle-o-notch fa-spin"></i>
      </div>
      <input type="text" class="form-control warning" disabled *ngIf="reportList && reportList.length <= 0"
        value="There are no accessible reports in the selected workspace" />
    </div>
  </div>
  <div *ngIf="PBIReportId && PBIReportId.errors && PBIReportId.errors.minlength"
    class="alert alert-danger">
    <div
      i18n="powerbi report incorrect or invalid|The error message when the powerbi report is invalid or with a broken link@@incorrectPowerBiReportTaskEditForm"
      *ngIf="PBIReportId.errors.minlength">The PowerBI report is in the wrong format and cannot be used</div>
  </div>
  <div class="form-row">
    <div class="col-8">
      <div class="form-group">
        <input type="hidden" class="page-array" formArrayName="PageList" />
        <label title="The list of pages of the report you wish to send"
          i18n-title="mouseover text explaining pages|The text that shows up on mouseover of the pages label to instruct the user what it is useful for, used in task wizard configuration step@@taskWizardPageMouseoverText"
          i18n="power bi page list label at task edit form|The page label that is present before the pages inside the report input selector@@powerBiPagesInputLabelTaskEditForm">Pages</label>
        <div class="input-wrapper" *ngIf="pageList && pageList.length > 0">
          <select class="form-control" (change)="onPageChange($event)">
            <option i18n="Select a page to add|The text that show up at the page selector if the PowerBI report has not been selected yet to load the pages and therefore there are no pages to display and the form is incomplete@@reportSelectedPages"
              value="">Select a page to add</option>
            <option *ngFor="let report of pageList" [value]="report.id">{{ report.label }}</option>
          </select>
        </div>
        <div class="input-wrapper page-checkbox-group loading-wrapper" *ngIf="!pageList">
          <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
        <div class="input-wrapper page-checkbox-group error-wrapper" *ngIf="pageList && pageList.length <= 0">
          <input
            type="text"
            class="form-control warning"
            disabled
            *ngIf="PBIReportId.touched"
            i18n-value="no accessible pages in report warning|The text that show up at the page selector if there are no accessible pages in the report to be selected and therefore the report cannot be selected@@noAccessiblePagesReportAvailableWarning"
            value="There are no accessible pages in the selected report" />
          <input
            type="text"
            class="form-control warning"
            disabled
            *ngIf="!PBIReportId.touched"
            i18n-value="waiting report selection to display pages|The text that show up at the page selector if the PowerBI report has not been selected yet to load the pages and therefore there are no pages to display and the form is incomplete@@reportMissingToShowPagesWarning"
            value="Select a report to show the pages within" />
        </div>
      </div>
    </div>
    <div class="col-2" *ngIf="pageList && pageList.length > 0">
      <button type="button" [disabled]="!isPageSelected()"
        class="btn btn-primary btn-with-left-icon view-button btn-block " (click)="onViewClick()">
        <i class="fa fa-external-link"></i>
        <span
          i18n="view report button label|The label of the view report button on the configuration step of the task edit form@@viewReportButtonLabelTaskEditForm">View</span>
      </button>
    </div>
    <div class="col-2" *ngIf="pageList && pageList.length > 0">
      <button type="button" [disabled]="!isPageSelected()" class="btn btn-primary btn-with-left-icon btn-block"
        (click)="addPage(bulkModal)">
        <i class="fa fa-plus"></i>
        <span
          i18n="add report button label|The label of the add report button on the configuration step of the task edit form@@addReportButtonLabelTaskEditForm">Add</span>
      </button>
    </div>
  </div>
  <div class="form-group">
    <label i18n="Page Selecteds@@pageSelecteds">Selected </label>
    <div class="input-wrapper">
      <div class="pages-wrapper" *ngIf="PageList.value.length > 0; else noObjects">
        <table class="table table-striped table-advance table-hover pages">
          <thead>
            <tr>
              <th >#</th>
              <th class="type" i18n="Page Name@@pageNameView">
                Page</th>
              <th i18n="Page Type@@pageSizeView">Page Type</th>
              <th i18n="Page Size@@pageSize">Size</th>
              <th class="actions" i18n="Actions column at the schedule list of a task@@actionsColumnLabelTaskEdit">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let obj of PageList.value" [attr.data-id]="obj.reportOrder">
              <td > {{obj.reportOrder }}</td>
              <td >{{ obj.name }}</td>
              <td >{{ obj.pageView }}</td>
              <td >{{ obj.pageView !='Custom' ? '-' : obj.width + ' x ' + obj.height }}</td>
              <td class="actions">
                <div class="btn btn-sm btn-primary" (click)="editPage(obj,bulkModal)"><i class="fa fa-pencil"></i></div>&nbsp;
                <div class="btn btn-sm btn-danger" (click)="onDeletePageClick(obj)"><i class="fa fa-trash"></i></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noObjects>
        <div class="missing-page-info">
          <h3
            i18n="no pages note|The message shown at the top of the page list when there are no pages registered to a task at the task edit form@@noRegisteredpagesTitleTaskForm">
            There are no pages for this task yet.</h3>
          <p>

            <span
              i18n="the label describing add page to the click here button|The label at the right of the button indicading that the button should be clicked to add a new delivery to a task form@@addNewPageButtonExplanation">
              Select a page into dropdown and click on Add button.</span>
          </p>
          <p class="long-description"
            i18n="add page description|The message explaining pages that is shown at the page list when there are no pages registered to a task at the task edit form@@noRegisteredpagesDescriptionTaskForm">
            To preview your page before adding, click on View button.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<app-pbi-report-view [openModal]="eventOpenmodal.asObservable()" [workspaceId]="lastSelectedWorkspaceId"
  [reportId]="lastSelectedReportId" [title]="lastSelectedPageTitle" [showFooter]="false" [showFilter]="false"
  [showPages]="false"></app-pbi-report-view>

<ng-template #bulkModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" i18n="Config Page@@configPageTitle">Config Page</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body configsize">
    <label for="pagesize" i18n="Page Size@@pageSizeView">Page Size</label>
    <select id="pagesize" class="form-control" [(ngModel)]="ps.pageView">
      <option value="16:9">16:9</option>
      <option value="4:3">4:3</option>
      <option value="Letter">Letter</option>
      <option value="Custom">Custom</option>
    </select>
    <div class="form-row" [style.visibility]="ps.pageView=='Custom'? 'visible' : 'hidden'">
      <div class="col-6">
        <label for="pagewidth" i18n="Page Width@@pageSizeWidth">Width</label>
        <input class="form-control" type="number" id="pagewidth" step="1" [(ngModel)]="ps.width">
      </div>
      <div class="col-6">
        <label for="pageHeight" i18n="Page Height@@pageSizeHeight">Height</label>
        <input class="form-control" type="number" id="pageHeight" step="1" [(ngModel)]="ps.height">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss('Close')" i18n="The label of the button used to close the contact form, cancelling changes if they were made, at the contact form modal@@cancelChangesContactAction">Close</button>
    <button [disabled]="checkConfigPage()" type="button" class="btn btn-info btn-with-left-icon"
    i18n="A generic button label to save or submit a form, sending the changes to the server@@genericSaveButton"
      (click)="modal.dismiss('Save')">
      Save
    </button>
  </div>
</ng-template>
